import type { GetRuneDataRes, RuneConllectionType, SpecialKey } from '@/types/rune'
import type { AdvanceUserAttrType } from '@/types/user'

export let runeCollection: RuneConllectionType = {}
export let runeBasicFactor: Partial<AdvanceUserAttrType> = {}
export let runeSpecialFactor: Partial<Record<SpecialKey, any>> = {}
export function setRuneData(res: GetRuneDataRes) {
  runeCollection = res.runeCollection
  runeBasicFactor = res.runeBasicFactor
  runeSpecialFactor = res.runeSpecialFactor
}

export function getRuneName(id: number) {
  return `💠 ${runeCollection[id].name}`
}
export function getRuneBasicAttrValue(key: keyof AdvanceUserAttrType, value: number, isRole: boolean) {
  if (!value) return 0
  const res = runeBasicFactor[key]! * value * (isRole ? 1.2 : 1)
  if (['atk', 'heat'].includes(key)) return Math.round(res)
  else return Number(res.toFixed(1))
}
